lmApp
  .controller('OverviewController', ['$scope', '$rootScope', '$q', '$timeout', '$http', 'StatisticsService', 'AssetService', 'SubscriberService',
    function ($scope, $rootScope, $q, $timeout, $http, StatisticsService, AssetService, SubscriberService) {
      $scope.reportData = {};
      $scope.loading = false;

      $scope.getReportData = function () {
        $scope.loading = true;
        $rootScope.showLinearProgress('#reportsLoader');

        var stat = {};

        stat.top = StatisticsService.GetTopContent();

        stat.history = StatisticsService.GetHistory({offset: 0, limit: 20});

        $q.all(stat)
          .then(function (responses) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#reportsLoader');

            if (responses.top.length) {
              $scope.reportData.vodTop = _.last(responses.top).top.movie;
              $scope.reportData.liveTop = _.last(responses.top).top.channel;
            }

            if (responses.history.length) {
              $scope.reportData.history = responses.history.map(function (data) {
                data.time = moment(data.timestamp * 1000).format('MMM Do YYYY, h:mm:ss a');

                AssetService.GetAssetById(data.asset_id)
                  .then(function (collection) {
                    if (collection.length) {
                      data.asset = collection[0];
                    }
                  });

                SubscriberService.GetSubscribers(data.subscriber_id)
                  .then(function (collcetion) {
                    if (collcetion.length) {
                      data.subscriber = collcetion[0];
                    }
                  });

                return data;
              });
            }
          })
          .catch(function (reason) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#reportsLoader');
            $rootScope.debugInfo(reason);
          });

      };

      $scope.setMapsPoints = function () {
        $scope.mapLoading = true;
        $rootScope.showLinearProgress('#mapLoader');

        StatisticsService.GetHistory({start: moment.utc().startOf('month')})
          .then(function (collection) {

            window.initialize = function () {
              var MY_MAPTYPE_ID = 'SotalCloud';

              var featureOpts = [
                {
                  "featureType": "water",
                  "stylers": [
                    {"weight": 0.1},
                    {"color": "#A5BFDD"}
                  ]
                }, {
                  "featureType": "landscape",
                  "stylers": [
                    {"color": "#ffffff"}
                  ]
                }, {
                  "featureType": "road",
                  "stylers": [
                    {"visibility": "off"}
                  ]
                }, {
                  "featureType": "poi",
                  "stylers": [
                    {"visibility": "off"}
                  ]
                }
              ];

              $scope.geocoder = new google.maps.Geocoder();
              var country = config[$rootScope.globals.currentUser.project] ? config[$rootScope.globals.currentUser.project].location : 'North America';

              $scope.geocoder.geocode({'address': country}, function (results, status) {
                if (status == google.maps.GeocoderStatus.OK) {
                  $scope.mapOptions = {
                    zoom: country !== 'North America' ? 8 : 4,
                    mapTypeControlOptions: {
                      mapTypeIds: [google.maps.MapTypeId.ROADMAP, MY_MAPTYPE_ID]
                    },
                    mapTypeId: MY_MAPTYPE_ID,
                    mapTypeControl: false,
                    scaleControl: false,
                    streetViewControl: false
                  };

                  $scope.map = new google.maps.Map(document.getElementById('map'), $scope.mapOptions);

                  var customMapType = new google.maps.StyledMapType(featureOpts, {name: 'SotalCloud'});

                  $scope.map.mapTypes.set(MY_MAPTYPE_ID, customMapType);

                  $scope.map.setCenter(results[0].geometry.location);
                }
              });

              $scope.heatmapData = [];
              var allQ = {};

              for (var i = 0; i < collection.length; i++) {
                var item = collection[i];

                if (item.ip && item.ip !== '127.0.0.1' && item.ip.indexOf('172.') !== 0) {
                  allQ[i] = $http.get('http://www.freegeoip.net/json/' + item.ip)
                    .then(function (res) {
                      var data = res.data;
                      var status = res.status;

                      $scope.status = status;
                      $scope.data = data;

                      $scope.heatmapData.push(
                        new google.maps.LatLng(data.latitude, data.longitude)
                      );
                      return $q.when();
                    }, function (res) {
                      var data = res.data;
                      var status = res.status;

                      $scope.data = data || "Request failed";
                      $scope.status = status;
                      return $q.when();
                    });
                }
              }

              $q.all(allQ)
                .then(function () {
                  $scope.mapLoading = false;
                  $rootScope.hideLinearProgress('#mapLoader');
                  $scope.heatmap = new google.maps.visualization.HeatmapLayer({
                    data: $scope.heatmapData
                  });
                  $scope.heatmap.setMap($scope.map);
                  $scope.heatmap.set('radius', 20);
                  var gradient = [
                    'rgba(0, 255, 255, 0)',
                    'rgba(0, 255, 255, 1)',
                    'rgba(0, 191, 255, 1)',
                    'rgba(0, 127, 255, 1)',
                    'rgba(0, 63, 255, 1)',
                    'rgba(0, 0, 255, 1)',
                    'rgba(0, 0, 223, 1)',
                    'rgba(0, 0, 191, 1)',
                    'rgba(0, 0, 159, 1)',
                    'rgba(0, 0, 127, 1)'
                  ];
                  $scope.heatmap.set('gradient', $scope.heatmap.get('gradient') ? null : gradient);
                })
                .catch(function () {
                  $scope.mapLoading = false;
                  $rootScope.hideLinearProgress('#mapLoader');
                });
            };

            if (!angular.element('#google_maps').length) {
              var script = document.createElement('script');
              script.id = 'google_maps';
              script.type = 'text/javascript';
              script.src = 'https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=visualization&callback=initialize&key=AIzaSyA0IUlaOotw8UDNkqLRFXkTH37kPBmVrJg';

              document.body.appendChild(script);
            } else {
              window.initialize();
            }
          })
          .catch(function (reason) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#reportsLoader');
            $rootScope.debugInfo(reason);
          });

      };

      $scope.getReportData();

      //$scope.setMapsPoints();

      window.initialize = function () {
        var MY_MAPTYPE_ID = 'SotalCloud';

        var featureOpts = [
          {
            "featureType": "water",
            "stylers": [
              {"weight": 0.1},
              {"color": "#A5BFDD"}
            ]
          }, {
            "featureType": "landscape",
            "stylers": [
              {"color": "#ffffff"}
            ]
          }, {
            "featureType": "road",
            "stylers": [
              {"visibility": "off"}
            ]
          }, {
            "featureType": "poi",
            "stylers": [
              {"visibility": "off"}
            ]
          }
        ];

        $scope.geocoder = new google.maps.Geocoder();
        var country = config[$rootScope.globals.currentUser.project] ? config[$rootScope.globals.currentUser.project].location : 'North America';

        $scope.geocoder.geocode({'address': country}, function (results, status) {
          if (status == google.maps.GeocoderStatus.OK) {
            $scope.mapOptions = {
              zoom: country !== 'North America' ? 8 : 4,
              mapTypeControlOptions: {
                mapTypeIds: [google.maps.MapTypeId.ROADMAP, MY_MAPTYPE_ID]
              },
              mapTypeId: MY_MAPTYPE_ID,
              mapTypeControl: false,
              scaleControl: false,
              streetViewControl: false
            };

            $scope.map = new google.maps.Map(document.getElementById('map'), $scope.mapOptions);

            var customMapType = new google.maps.StyledMapType(featureOpts, {name: 'SotalCloud'});

            $scope.map.mapTypes.set(MY_MAPTYPE_ID, customMapType);

            $scope.map.setCenter(results[0].geometry.location);
          }
        });
      };

      if (!angular.element('#google_maps').length) {
        var script = document.createElement('script');
        script.id = 'google_maps';
        script.type = 'text/javascript';
        script.src = 'https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=visualization&callback=initialize&key=AIzaSyA0IUlaOotw8UDNkqLRFXkTH37kPBmVrJg';

        document.body.appendChild(script);
      } else {
        window.initialize();
      }
    }]);
